module.exports = __webpack_public_path__ + "media/images/donation/donation_share_panel_symbol-48312102f1e0cd493c09c3bd8b4a77cd.svg";